module.exports = __webpack_public_path__ + "img/icon-loading.5324b6f1.jpg";